import React from "react";
import "./style.css";
import { CourseLandingHeaderInfo } from "../CourseLandingHeaderInfo";
import { useEffect } from 'react';


export const CourseLandingLoopVideo = ({ loop = null, loop_image = null, video = null, default_subtitles, language, subtitles_dir = "", course_title, course_type="", course_teacher_name, isMobile, undertitle_text }) => {

  const stopFSVideo = () => {

    if (document.getElementById('reveal_block_div'))
      document.getElementById('reveal_block_div').style.display = "block";

    if (document.getElementById('inside_loop_video_wrapper'))
      document.getElementById('inside_loop_video_wrapper').classList.add('d-none');

    if (document.getElementById('inside_loop_video'))
      document.getElementById('inside_loop_video').classList.add('d-none');

    if ( document.getElementsByClassName('landing_loop_div')[0] )
      document.getElementsByClassName('landing_loop_div')[0].style.opacity = .4;

    const elem = document.getElementById("inside_loop_video");

    elem.pause();

  };

  function fullscreenchangeFunction() {
    if (!document.fullscreenElement) {
      stopFSVideo();
    }
  }

  function webkitendfullscreenFunction() {
    stopFSVideo();
  }

  useEffect(() => {

    document.addEventListener("fullscreenchange", fullscreenchangeFunction);

    const video_element = document.getElementById("inside_loop_video");

    if (!video_element) {
      console.info("video_element not yet ready");
      return;
    }

    //console.info("video_element is ready");

    video_element.addEventListener("webkitendfullscreen", webkitendfullscreenFunction, false);

    return () => {

      document.removeEventListener("fullscreenchange", fullscreenchangeFunction);

      const video_element = document.getElementById("inside_loop_video");

      if (!video_element) {
        console.info("video_element not yet ready");
        return;
      }

      //console.info("video_element is ready");

      video_element.removeEventListener("webkitendfullscreen", webkitendfullscreenFunction);

    };
  }, [fullscreenchangeFunction, webkitendfullscreenFunction]);

  if (loop && video)
    return (
      <>
        <div id="reveal_block_div" className="ml-2">


          {
            !isMobile &&
            <CourseLandingHeaderInfo
              course_title={course_title}
              course_teacher_name={course_teacher_name}
              language={language}
              course_type={course_type}
              undertitle_text={undertitle_text}
            />
          }

          <video crossOrigin="anonymous" id="loop_video" autoPlay muted loop playsInline>
            <source key={`https://newcdn.10masters.com${loop}`} type="video/mp4" src={`https://newcdn.10masters.com${loop}`} />
          </video>
          {/*<img id="loop_video_removed" src={`https://newmedia.10masters.com/${loop_image}`} />*/}
          <div className="landing_loop_div_blur"></div>
        </div>

        <div className="landing_loop_div">

          <div id="inside_loop_video_wrapper" className="block_video d-none">

            <video id="inside_loop_video" controls className="d-none w-100 mb-5" crossOrigin="anonymous">
              <source src={`https://newcdn.10masters.com${video}.mp4`} type="video/mp4" />
              <source src={`https://newcdn.10masters.com${video}.webm`} type="video/webm" />

              isMobile &&
              <track kind="subtitles" label="No" default={true} srcLang="no" src={`https://newcdn.10masters.com/reactweb/static/empty.es.vtt`} />

              {
                !isMobile &&
                <>
                  <track kind="subtitles" label="Español" default={default_subtitles === 'es'} srcLang="es" src={`https://newcdn.10masters.com${subtitles_dir}/subtitles.es.vtt`} />
                  <track kind="subtitles" label="English" default={default_subtitles === 'en'} srcLang="en" src={`https://newcdn.10masters.com${subtitles_dir}/subtitles.en.vtt`} />
                  <track kind="subtitles" label="Français" default={default_subtitles === 'fr'} srcLang="fr" src={`https://newcdn.10masters.com${subtitles_dir}/subtitles.fr.vtt`} />
                  <track kind="subtitles" label="Português" default={default_subtitles === 'pt'} srcLang="pt" src={`https://newcdn.10masters.com${subtitles_dir}/subtitles.pt.vtt`} />
                </>
              }

              <track kind="subtitles" label="Italiano (auto)" default={default_subtitles === 'it'} srcLang="it" src={`https://newcdn.10masters.com${subtitles_dir}/subtitles.it.vtt`} />
              <track kind="subtitles" label="Deutsch (auto)" default={default_subtitles === 'de'} srcLang="de" src={`https://newcdn.10masters.com${subtitles_dir}/subtitles.de.vtt`} />
              <track kind="subtitles" label="Polski (auto)" default={default_subtitles === 'pl'} srcLang="pl" src={`https://newcdn.10masters.com${subtitles_dir}/subtitles.pl.vtt`} />
              <track kind="subtitles" label="Čeština (auto)" default={default_subtitles === 'cs'} srcLang="cs" src={`https://newcdn.10masters.com${subtitles_dir}/subtitles.cs.vtt`} />
            </video>

          </div>

        </div>

      </>
    );

};
